module.exports = __webpack_public_path__ + "static/media/timelapse_26.196b4704.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_26.jpg
// module id = 984
// module chunks = 0